<script setup>
import WebsiteForm from '@frontJs/components/forms/projectManagement/dev/WebsiteForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, phpVersions, cms } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    phpVersions: {
        type: Array,
        required: true,
    },
    cms: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Mettre à jour le site web #{{ tenant.id }} - DEV - Gestion de projet
            - Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - DEV - Mettre à jour le site web #{{ tenant.id }}
    </PageTitle>

    <WebsiteForm :tenant="tenant" :php-versions="phpVersions" :cms="cms" />
</template>
